module.exports = __webpack_public_path__ + "images/168_160.jpg";